import { useEffect } from "react";

// Keeps CSS variables in sync with the true VISIBLE viewport (window.visualViewport):
//   --app-height : the visible height (shrinks when the mobile keyboard opens)
//   --app-top    : the visible viewport's top offset within the layout viewport
//
// On mobile the virtual keyboard shrinks window.visualViewport but NOT 100dvh, and
// it can also push the layout viewport (non-zero offsetTop) or let the page scroll.
// The app shell is position:fixed and anchored to these vars so it exactly overlaps
// the visible area, keeping the chat input pinned to the bottom instead of floating
// mid-screen or scrolling above the top.
export function useVisualViewport() {
  useEffect(() => {
    const vv = window.visualViewport;
    const root = document.documentElement;

    const apply = () => {
      const h = vv ? vv.height : window.innerHeight;
      const top = vv ? vv.offsetTop : 0;
      root.style.setProperty("--app-height", `${Math.round(h)}px`);
      root.style.setProperty("--app-top", `${Math.round(top)}px`);
    };

    apply();

    if (vv) {
      vv.addEventListener("resize", apply);
      vv.addEventListener("scroll", apply);
    }
    window.addEventListener("resize", apply);
    window.addEventListener("orientationchange", apply);

    return () => {
      if (vv) {
        vv.removeEventListener("resize", apply);
        vv.removeEventListener("scroll", apply);
      }
      window.removeEventListener("resize", apply);
      window.removeEventListener("orientationchange", apply);
      root.style.removeProperty("--app-height");
      root.style.removeProperty("--app-top");
    };
  }, []);
}
